<div class="p-4 name-campaign-dialog">
  <div class="d-flex justify-content-between align-items-start mb-3">
    <div class="name-campaign-icon">
      <i class="pi pi-save"></i>
    </div>
    <button
      type="button"
      class="btn btn-sm rounded hover:bg-gray-200"
      (click)="cancel()"
      aria-label="Close"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <h4 class="fw-bold mb-2">Name this {{ data.channelLabel }} campaign</h4>
  <p class="text-muted mb-3">Give this campaign a name so it can be saved, reopened and shared.</p>

  <form (ngSubmit)="save()">
    <label for="campaignNameInput" class="form-label fw-semibold">Campaign name</label>
    <p-autocomplete
      inputId="campaignNameInput"
      [ngModel]="campaignName"
      (ngModelChange)="onNameChange($event)"
      name="campaignName"
      [suggestions]="suggestions"
      (completeMethod)="search($event)"
      (onSelect)="onSelectExisting($event)"
      optionLabel="campaignName"
      [forceSelection]="false"
      [autofocus]="true"
      placeholder="Campaign name"
      [inputStyleClass]="'form-control' + (errorMessage ? ' is-invalid' : '')"
      styleClass="w-100"
    ></p-autocomplete>
    <div class="invalid-feedback d-block" *ngIf="errorMessage">{{ errorMessage }}</div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
      <button type="submit" class="btn btn-primary">Save campaign</button>
    </div>
  </form>
</div>
